import React, { useState, useEffect, Fragment } from "react";
import { Button, Container, Row, Col, FormGroup, Label, Input, Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";
import { Breadcrumbs } from "../../AbstractElements";

const UpdateTermsAndPolicy = () => {
  const [policyData, setPolicyData] = useState({ content: "", title: "", _id: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.userToken);

  useEffect(() => {
    // Fetch the policy data on component mount
    const fetchPolicy = async () => {
      try {
        const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/policy`, {}, token);
        const policy = response.data[0]; // Assuming the first item is the policy we need
        setPolicyData(policy);
      } catch (error) {
        console.error("Error fetching policy:", error);
      }
    };

    fetchPolicy();
  }, [token]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    setLoading(true);
    try {
      await apiRequest('put', `${process.env.REACT_APP_API_BASE_URL}/admin/policy/${policyData._id}`, { content: policyData.content }, token);
      setIsEditing(false);
      setLoading(false);

    } catch (error) {
      console.error("Error updating policy:", error);
      alert("Error updating policy. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setPolicyData({ ...policyData, content: event.target.value });
  };

  return (
    <Fragment>
    <Breadcrumbs mainTitle="Terms and Conditions" parent="Dashboard" title="All Terms and Conditions" />
    <Container fluid={true}>
      <Row>
        <Col sm="12">
          <FormGroup>
            <Label for="policyContent">{policyData.title}</Label>
            <Input
              type="textarea"
              id="policyContent"
              value={policyData.content}
              onChange={handleChange}
              disabled={!isEditing}
              rows="10"
            />
          </FormGroup>
        </Col>
        <Col sm="12">
          {isEditing ? (
            <Button color="primary" onClick={handleSaveClick} disabled={loading || !policyData.content}>
              {loading ? <Spinner size="sm" /> : "Save"}
            </Button>
          ) : (
            <Button color="secondary" onClick={handleEditClick}>
              Edit
            </Button>
          )}
        </Col>
      </Row>
    </Container>
        </Fragment>
  );
};

export default UpdateTermsAndPolicy;
